import { render, staticRenderFns } from "./InsuranceStatement.vue?vue&type=template&id=0cc494a2"
import script from "./InsuranceStatement.vue?vue&type=script&lang=js"
export * from "./InsuranceStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports